import { useQuery } from '@tanstack/react-query';
import { requestMemberBillingProfile } from './paymentApi';

/** Shared so mutation hooks can invalidate this query after a successful add. */
export const memberBillingProfileKey = ['payments', 'billingProfile'] as const;

/**
 * Billing-address prefill + AutoPay enrollment for the Add Payment Account modal.
 * Stub-backed (Phase 4); the real query reads these fields off the member object.
 */
export function useMemberBillingProfile() {
  return useQuery({
    queryKey: memberBillingProfileKey,
    queryFn: requestMemberBillingProfile,
  });
}
